import { Link } from "react-router-dom";

const stats = [
  { value: "21+", label: "精选视频" },
  { value: "3", label: "内容分类" },
  { value: "每日", label: "资讯更新" },
  { value: "全端", label: "随时观看" },
];

export default function SiteIntro() {
  return (
    <section className="w-full px-4 md:px-8 pb-12 md:pb-16">
      <div className="rounded-lg bg-secondary-950 text-background-100 p-8 md:p-12 grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
        <div>
          <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-medium mb-4">
            关于日皮视频
          </span>
          <h2 className="font-heading font-black text-2xl md:text-3xl text-background-50 leading-tight">
            每天看点好的，从一个值得信赖的视频平台开始
          </h2>
          <p className="mt-4 text-sm md:text-base text-background-300 leading-relaxed">
            日皮视频聚合最新影视资讯、精选短片与热门剪辑，帮你用最短的时间读懂行业动态、看遍高能名场面。我们坚持内容结构化、分类清晰、浏览顺滑，让找视频这件事变得简单。
          </p>
          <Link
            to="/about"
            className="mt-6 inline-flex items-center gap-2 px-6 py-3 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium whitespace-nowrap cursor-pointer transition-colors"
          >
            了解更多 <i className="ri-arrow-right-line" />
          </Link>
        </div>
        <div className="grid grid-cols-2 gap-4">
          {stats.map((item) => (
            <div
              key={item.label}
              className="rounded-lg bg-secondary-900 border border-secondary-800 p-5"
            >
              <div className="font-heading font-black text-2xl md:text-3xl text-accent-400">
                {item.value}
              </div>
              <div className="mt-1 text-xs md:text-sm text-background-300">
                {item.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}